import { getV1, postV1, delV1, putV1, getGFT, postGFT } from '@/common/utils/ajax'

import { DEFAULT_PER } from '@/config'

const getHistory = (page) => getV1(`tim_sessions?status=all`, {
    page,
    per: DEFAULT_PER
})

const getHistoryChat = (id, page, per = DEFAULT_PER) => getV1(`tim_sessions/${id}/tim_messages`, {
    page,
    per
})

const getExpressions = () => getV1('frequent_expressions')
const updateExpression = (id, data) => putV1(`frequent_expressions/${id}`, data)
const createExpression = (content) => postV1('frequent_expressions', { content })
const deleteExpression = (id) => delV1(`frequent_expressions/${id}`)

const check422 = (data) => {
    if (data.code === 422) {
        wx.showModal({
            title: '提示',
            content: data.error_message,
            showCancel: false
        })
    }
    return data
}

const askPhone = (id) => postV1(`tim_sessions/${id}/tim_asked_phone`).then(check422)
const rejectPhoneAsk = (id) => postV1(`tim_sessions/${id}/tim_asked_phone/reject`).then(check422)
const acceptPhoneAsk = (id) => postV1(`tim_sessions/${id}/tim_asked_phone/accept`).then(check422)

const rateConsultant = (consultant_id, rating) => postV1('consultant_ratings', {
    consultant_id,
    rating
})

const updateAutoreplySeq = (id, params) => putV1(`frequent_expressions/${id}/autoreply_seq`, params)

const getRatingAuth = (consultant_id) => getGFT('v1/consultant_ratings/new',{consultant_id})

const addRating = (consultant_id, rating) => postGFT('v1/consultant_ratings',{
    consultant_id,
    rating
})

export default {
    getHistory,
    getHistoryChat,
    getExpressions,
    createExpression,
    updateExpression,
    deleteExpression,
    askPhone,
    rejectPhoneAsk,
    acceptPhoneAsk,
    rateConsultant,
    updateAutoreplySeq,
    getRatingAuth,
    addRating
}
